export class SetOrganisationRoleAction {
  public static readonly type = '[Authorisation] SetOrganisationRoleAction';
  constructor(
    public readonly userId: string,
    public readonly organisationId: string,
  ) {}
}
